export enum DialogColors {
  Accent = 0,
  Warn = 1,
}
